import ArrowUpIcon from "../../../../public/assets/arrow-collapse-up.svg";

export default ArrowUpIcon;
